import {useState} from 'react';

import {Button} from 'shells/button/button';
import {EmbedOrShareModal} from 'shells/embed-or-share-modal/embed-or-share-modal';

import type {MultiPageFormFragment} from 'nutshell-graphql-types';

interface Props {
    form: MultiPageFormFragment | null | undefined;
}

export function MultiPageEmbedFormButton(props: Props) {
    const [isShowingEmbedFormPopover, setIsShowingEmbedFormPopover] = useState<boolean>(false);

    return (
        <>
            <Button
                disabled={!props.form}
                variant='primary'
                size='big'
                onClick={() => setIsShowingEmbedFormPopover(true)}
            >
                Embed form
            </Button>
            {isShowingEmbedFormPopover && props.form ? (
                <EmbedOrShareModal
                    onClose={() => setIsShowingEmbedFormPopover(false)}
                    header={`Embed ${props.form.name} on your site`}
                    embedInfoPopoverText='Copy and paste this code snippet into your website where you’d like to show this Nutshell form.'
                    copyableLink={props.form.sharableViewInBrowserLink}
                    codeSnippet={props.form.embedSnippet}
                    copyableLinkLabel='Shareable URL'
                    copyableLinkDescription='If you’d rather link to a full-page form (like on a website, newsletter, or in an email to a colleague), copy & use this link:'
                />
            ) : undefined}
        </>
    );
}
